import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { IngresoService } from '../../servicios/ingreso.service';

@Component({
  selector: 'app-educativa-consultas',
  templateUrl: './educativa-consultas.component.html',
  styleUrls: ['./educativa-consultas.component.css']
})
export class EducativaConsultasComponent implements OnInit {

  public mr: NgbModalRef;
  public vecCarrera = []; public vecEstudiante = []; public vecMotivo = []; public vecConsulta = []; public vecActividad = []; vecCitas = []; public vecVerActividad = [];
  public vecGrupos = []; public vecInfoGrupos = []; numeroHC: string = ''; public vecInfoEst = [];
  public encabezado: string = ""; public nombreBeca: string = ""; public buscar: string = ''; public criterioBusca: string = ''; private idConsulta: number = 0;//1804404836 0706163557
  fechaHoy: string = ""; horaHoy: string = ""; opEditable: boolean = true; opActividad: boolean = true; private banGuarda = true; opModGrupos: boolean = true; opAddCita: boolean = false;

  constructor(private modalService: NgbModal, private alerti: AlertifyService, private srvSelect: SeleccionService, private cargando: LoaderComponent,
    private srvInsert: IngresoService) { }

  ngOnInit() {
    this.calculoFecha();
    this.encabezado = "Pisicología educativa";
    this.nombreBeca = localStorage.getItem('modNom');
    this.instanciaVariables(); this.verInfoGruposPaciente(15, 'na', 'na');
    this.cargarFacultades();
    this.cargarMotivoConsulta();
  }
  //FUNCION PARA MOSTRAR TODAS LAS DISCAPACIDADES
  async verInfoGruposPaciente(op, param1, param2) {
    this.vecInfoGrupos = [];
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.medicoOtrosDatos(op, param1, param2).subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success)
      this.vecInfoGrupos = resGrupo.consulta;
  }
  //FUNCION PARA MOSTRAR TODAS LAS DISCAPACIDADES
  async verGruposPaciente(op, param1, param2) {
    const resGrupo = await new Promise<any>(resolve =>
      this.srvSelect.medicoOtrosDatos(op, param1, param2).subscribe(translated => {
        resolve(translated)
      }));
    if (resGrupo.success) {
      if (op == 4) {
        this.vecGrupos[0]['etnia'] = resGrupo.consulta[0]['idEtnia'];
        this.vecGrupos[0]['banEtnia'] = 1
      }
      if (op == 5) {
        this.vecGrupos[0]['grupo'] = resGrupo.consulta[0]['idGrupo'];
        this.vecGrupos[0]['banGrupo'] = 1
      }
      if (op == 6) {
        this.vecGrupos[0]['diverso'] = resGrupo.consulta[0]['diversidad'];
        this.vecGrupos[0]['banDiverso'] = 1
      }
      if (op == 8) {
        this.vecGrupos[0]['discap'] = resGrupo.consulta[0]['idDiscapacidad'];
        this.vecGrupos[0]['porc'] = resGrupo.consulta[0]['porcentaje'];
        this.vecGrupos[0]['banDiscap'] = 1
      }
    }
  }

  //FUNCION PARA ABRIR EL MODAL QUE PERMITE BUSCAR UN ESTUDIANTE
  bucarEstudiante(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //FUNCION QUE CARGA LOS MOTIVOS DE CONSULTA DE PSE
  async cargarMotivoConsulta() {
    this.vecMotivo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPsicologiaE(1, 'na', 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecMotivo = res.consulta;
    }
  }
  //FUNCION QUE CARGA LAS ACTIVIDADES DE UNA CONSULTA
  async cargarActividadConsulta(consulta) {
    this.vecVerActividad = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPsicologiaE(5, consulta, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecVerActividad = res.consulta;
    }
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarFacultades() {
    this.vecCarrera = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let i in res.carrera)
        this.carreraFaculta(res.carrera[i]['strCodigo']);
    }
  }

  //FUNCION QUE CARGA TODAS LAS CARRERAS QUE PERTENECE A UNA FACULTAD
  async carreraFaculta(fac) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(2, fac, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let j in res.carrera) {
        this.vecCarrera.push({
          codFac: res.carrera[j]['codFacultad'],
          nombFac: res.carrera[j]['nombFacultad'],
          codCarr: res.carrera[j]['codCarrera'],
          nombCarr: res.carrera[j]['nombCarrera'],
          baseCarr: res.carrera[j]['baseDatos'],
        });
      }
    }
  }
  //CRITERIO DE VARIAS OPCIONES DE BUESQUEDA DE UN ESTUDIANTE
  async criterioBuscarEstudiante() {
    this.vecInfoEst = [];
    const resEstudiantes = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(9, this.criterioBusca, 'na', 'na').subscribe(translated => { resolve(translated) }));
    if (resEstudiantes.success) {
      this.vecInfoEst = resEstudiantes.carrera;
    }
  }
  //BUSCAMOS LA MATRICULA DEL ESTUDIANTE
  async buscarEstudiante(datoEst) {
    this.buscar = datoEst.strCedula.replace('-', '');
    localStorage.setItem('buscarConsulta', datoEst.strCedula.replace('-', ''));
    this.opAddCita = true;
    this.nuevaCitaPSE(); this.vecCitas = [];
    let i = 0; let ban = 0; this.opEditable = true; var codPerriodo = '';
    this.instanciaVariables();

    this.cargando.abrir();
    this.cerrarModal();
    if (this.buscar) {

      const resMatrCarrera = await new Promise<any>(resolve =>
        this.srvSelect.gestionMatricula(1, 'na', this.buscar, 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resMatrCarrera.success) {

        while (i < resMatrCarrera.matricula.length && ban == 0) {

          const res = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(3, resMatrCarrera.matricula[i]['baseCarrera'], this.buscar, 'na', 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (res.success) {
            this.obtenerDatosCentralizada(this.buscar, resMatrCarrera.matricula[i]['nombFacultad'], resMatrCarrera.matricula[i]['nombCarrera'], res.matricula[0]['strCodNivel'],
              resMatrCarrera.matricula[i]['baseCarrera'], res.matricula[0]['strCodPeriodo']);
            this.verHistoria(this.buscar);
            ban = 1; this.opEditable = false;
            this.vecEstudiante[0]['tipoEst'] = 'Estudiante';
          }
          i++;
        }
        if (ban == 0) {
          i = 0; ban = 0; this.opEditable = true;
          while (i < resMatrCarrera.matricula.length && ban == 0) {
            const resEgreso = await new Promise<any>(resolve =>
              this.srvSelect.gestionMatricula(31, resMatrCarrera.matricula[i]['baseCarrera'], this.buscar, 'na', 'na').subscribe(translated => {
                resolve(translated)
              }));
            if (resEgreso.success) {
              this.obtenerDatosCentralizada(this.buscar, resMatrCarrera.matricula[i]['nombFacultad'], resMatrCarrera.matricula[i]['nombCarrera'], 'E',
                resMatrCarrera.matricula[i]['baseCarrera'], codPerriodo);
              this.verHistoria(this.buscar);
              ban = 1; this.opEditable = false;
              this.vecEstudiante[0]['tipoEst'] = 'Egresado';

              const resTitula = await new Promise<any>(resolve =>
                this.srvSelect.gestionMatricula(32, resMatrCarrera.matricula[i]['baseCarrera'], resEgreso.matricula[0]['intCodigo'], 'na', 'na').subscribe(translated => {
                  resolve(translated)
                }));
              if (resTitula.success) {
                this.alerti.error('El estudiante ya se encuentra titulado');
                ban = 0; this.opEditable = true;
                this.vecEstudiante[0]['tipoEst'] = 'Titulado';
              }
            }
            i++;
          }
        }
      }
      if (ban == 0) {
        this.alerti.error('No se encontró al estudiante.');
        //this.opAddCita = false;
        this.obtenerDatosCentralizada(this.buscar, resMatrCarrera.matricula[0]['nombFacultad'], resMatrCarrera.matricula[0]['nombCarrera'], 'ND',
          resMatrCarrera.matricula[0]['baseCarrera'], 'Cerrado'); this.verHistoria(this.buscar);
        ban = 1; this.opEditable = false;
        this.vecEstudiante[0]['tipoEst'] = 'Estudiante';
      }
      this.datosFicha();
    }
    else
      this.alerti.error('Debe ingresar el número de cédula del estudiante.');
    this.cargando.cerrar();
  }

  async datosFicha() {
    const resFicha = await new Promise<any>(resolve =>
      this.srvSelect.gestionEncuesta(25, this.buscar, '33', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resFicha.success) {
      this.vecEstudiante[0]['celular'] = resFicha.encuesta[0]['strRespuesta'];
    }
  }
  //BUSCAMOS LA hce DEL ESTUDIANTE
  async verHistoria(estudiante) {
    const resHC = await new Promise<any>(resolve => this.srvSelect.medicoHistoriaClinica(estudiante).subscribe(translated => {
      resolve(translated)
    }));
    if (resHC.success) {
      this.numeroHC = resHC.roles[0]['NUM_CLINICA'];
      this.vecGrupos[0]['celular'] = resHC.roles[0]['celular'];
      this.verGruposPaciente(4, resHC.roles[0]['NUM_CLINICA'], 'na');//ETNIA
      this.verGruposPaciente(5, resHC.roles[0]['NUM_CLINICA'], 'na');//GRUPO VULNERABLE
      this.verGruposPaciente(6, resHC.roles[0]['NUM_CLINICA'], 'na');//DIVERSIDAD SEXUAL
      this.verGruposPaciente(8, resHC.roles[0]['NUM_CLINICA'], 'na');//DISCAPACIDAD
      this.opModGrupos = false;
    }
    else {
      this.alerti.warning('El estudiante no dispone de historia clínica, por lo que no muestra datos referentes a etnia, etc.');
      this.opModGrupos = true;
    }
  }
  //OBTENER LOS DATOS DEL ESTUDIANTE DE LA CENTRALIZADA
  obtenerDatosCentralizada(buscar, facultad, carrera, nivel, baseCarrera, periodo) {
    this.srvSelect.personaCentralDocumento(buscar).subscribe(data => {
      if (data.success) {
        this.vecEstudiante[0]['estudiante'] = data.datos['per_nombres'] + ' ' + data.datos['per_primerApellido'] + ' ' + data.datos['per_segundoApellido'];
        this.vecEstudiante[0]['correo'] = data.datos['per_email'];
        this.vecEstudiante[0]['nombFacultad'] = facultad;
        this.vecEstudiante[0]['nombCarrera'] = carrera;
        this.vecEstudiante[0]['codNivel'] = nivel;
        this.vecEstudiante[0]['carrera'] = baseCarrera;
        this.vecEstudiante[0]['periodo'] = periodo;
        this.cargarCitasEstudiante();
      } else {
        this.alerti.error('No se encontró al estudiante');
      }
    });
  }
  //FUNCION QUE CARGA TODAS LAS CONSULTAS DE PSE DEL ESTUDIANTE
  async cargarCitasEstudiante() {
    this.vecCitas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPsicologiaE(2, this.buscar, localStorage.getItem('idPersona'), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecCitas = res.consulta;
    }
  }
  //FUNCION QUE CARGA LA ULTIMA CONSULTAS DE PSE DEL ESTUDIANTE REGISTRADA
  async cargarUltimaCitasEst() {
    this.vecCitas = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionPsicologiaE(4, this.buscar, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.idConsulta = res.consulta['0']['intIdConsulta']; this.banGuarda = false; this.opActividad = false;
    }
  }
  //GESTIONA LAS CONSULTAS SEGUN SEA EL CASO
  opcionesConsulta(op) {
    if (!this.opEditable) {
      if (op == 1) {
        if (!this.opEditable)
          if (this.banGuarda) {
            this.ingresoConsultaPSE(this.vecConsulta[0]['motivo'], this.vecConsulta[0]['diagnostico'], this.buscar, this.vecEstudiante[0]['carrera'],
              this.vecEstudiante[0]['codNivel'], this.vecEstudiante[0]['periodo'], this.vecConsulta[0]['fecha'], localStorage.getItem('idPersona'), this.vecEstudiante[0]['tipoEst'], 1);
          } else
            this.ingresoConsultaPSE(this.idConsulta, this.vecConsulta[0]['fecha'], this.vecConsulta[0]['motivo'], this.vecConsulta[0]['diagnostico'], 1, 'na', 'na', 'na', 'na', 4);
      }
      if (op == 2) {
        if (this.idConsulta > 0) {
          this.alerti.confirm('Etá seguro de eliminar la consulta seleccionada.', () => {
            this.ingresoConsultaPSE(this.idConsulta, this.vecConsulta[0]['fecha'], this.vecConsulta[0]['motivo'], this.vecConsulta[0]['diagnostico'], 0, 'na', 'na', 'na', 'na', 4);
          });
        }
        else
          this.alerti.error('Debe seleccionar una consulta');
      }
    }
    else
      this.alerti.error('No puede realizar esta actividad');
  }
  //GESTIONA LAS ACTIVIDADES DE LA CONSULTA PSE
  opcionActividad(op, actividad) {
    if (!this.opActividad) {
      if (op == 1)
        this.ingresoConsultaPSE(actividad['intIdAct'], actividad['strDetalle'], actividad['dtFecha'], 1, actividad['consulta'], 'na', 'na', 'na', 'na', 3);
      if (op == 2) {
        this.alerti.confirm('Etá seguro de eliminar la actividad seleccionada.', () => {
          this.ingresoConsultaPSE(actividad['intIdAct'], actividad['strDetalle'], actividad['dtFecha'], 0, actividad['consulta'], 'na', 'na', 'na', 'na', 3);
          this.nuevaCitaPSE();
        });
      }
    }
    else
      this.alerti.error('No puede realizar esta actividad');
  }
  //GUARDAR LAS ACTIVIDADES DE UNA CONSULTA DE PSE
  guardarActividad() {
    if (this.vecActividad[0]['actividad'] != '')
      this.ingresoConsultaPSE(this.vecActividad[0]['actividad'], 1, this.vecActividad[0]['fecha'], this.idConsulta, 'na', 'na', 'na', 'na', 'na', 2);
    else
      this.alerti.error('Debe ingresar el detalle de la actividad');
  }
  //LISTA LAS FECHAS DE LAS CONSULTAS DE UN ESTUDIANTE
  verConsultasFechas(cita) {
    this.banGuarda = false; this.idConsulta = cita['intIdConsulta'];
    this.cargarActividadConsulta(cita['intIdConsulta'])
    this.vecConsulta = [];
    this.vecConsulta.push({
      fecha: cita.dtFecha.split('T')[0], motivo: cita.intMotivo, diagnostico: cita.strDiagnostico, atiende: cita.strNombres + ' ' + cita.strApellidos
    });
    if (cita.intPersona == localStorage.getItem('idPersona')) {
      this.opActividad = false; this.opEditable = false;
    }
    else {
      this.opActividad = true; this.opEditable = true;
    }
  }
  //FUNCION QUE GUARDA O EDITA UNA CONSULTA PSE O UNA ACTIVIDAD DE LA CONSULTA
  ingresoConsultaPSE(param1, param2, param3, param4, param5, param6, param7, param8, param9, op) {
    var mensaje = '';
    this.srvInsert.ingresoGestionPsicologiaE(param1, param2, param3, param4, param5, param6, param7, param8, param9, op).subscribe(res => {
      if (res.consulta) {
        if (op == 1) {
          this.cargarCitasEstudiante();
          this.cargarUltimaCitasEst();
        }
        if (op == 2) {
          this.vecActividad = [];
          this.vecActividad.push({ fecha: this.fechaHoy, actividad: '' });
          this.cargarActividadConsulta(param4);
        }
        if (op == 3)
          this.cargarActividadConsulta(param5);
        if (op == 4)
          this.cargarCitasEstudiante();

        mensaje = op == 1 || op == 2 || op == 4 ? 'Consulta ejecutada correctamente' : op == 3 ? 'Actividad ejecutada correctamente' : '';
        this.alerti.success(mensaje);
      }
      else
        this.alerti.error('Falló al guardar los datos');
    });
  }
  //NUEVA CONSULTA DE PSE
  nuevaCitaPSE() {
    if (this.opAddCita) {
      this.banGuarda = true; this.opActividad = true; this.idConsulta = 0; this.opEditable = false; //this.vecCitas = [];
      this.vecConsulta = []; this.vecActividad = []; this.vecVerActividad = [];
      this.vecConsulta.push({ fecha: this.fechaHoy, motivo: 1, diagnostico: '', atiende: localStorage.getItem('localNombUsuario') });
      this.vecActividad.push({ fecha: this.fechaHoy, actividad: '' });
    } else
      this.alerti.error('Actividad no permitida');
  }
  guardarOtrosGrupos(op) {
    if (op == 1) {//CONDICION PARA INGRESAR O EDITAR LA ETNIA DEL ESTUDIANTE ACTUAL 1-2
      this.srvInsert.medicoIngresoOtrosDatos(this.vecGrupos[0]['banEtnia'] == 0 ? 1 : 2, this.vecGrupos[0]['etnia'], this.numeroHC, 'na', 'na').subscribe(res => {
        if (!res.proceso)
          this.alerti.error("Error al guardar la etnia");
      });
    }

    if (op == 2) {//CONDICION PARA INGRESAR O EDITAR LA DIVERSIDAD DE SEXO DEL ESTUDIANTE ACTUAL 5-6
      this.srvInsert.medicoIngresoOtrosDatos(this.vecGrupos[0]['banDiverso'] == 0 ? 5 : 6, this.vecGrupos[0]['diverso'], this.numeroHC, 'na', 'na').subscribe(res => {
        if (!res.proceso)
          this.alerti.error("Error al guardar la diversidad de sexo");
      });
    }

    if (op == 3) {//CONDICION PARA INGRESAR O EDITAR LA DISCAPACIDAD DEL ESTUDIANTE ACTUAL 7-8
      this.srvInsert.medicoIngresoOtrosDatos(this.vecGrupos[0]['banDiscap'] == 0 ? 7 : 8, this.vecGrupos[0]['discap'], this.numeroHC, this.vecGrupos[0]['porc'], 'na').subscribe(res => {
        if (!res.proceso)
          this.alerti.error("Error al guardar el grupo vulnerable");
      });
    }
    if (op == 4) {//CONDICION PARA INGRESAR O EDITAR EL GRUPO VULNERABLE DEL ESTUDIANTE ACTUAL 3-4      
      this.srvInsert.medicoIngresoOtrosDatos(this.vecGrupos[0]['banGrupo'] == 0 ? 3 : 4, this.vecGrupos[0]['grupo'], this.numeroHC, 'na', 'na').subscribe(res => {
        if (!res.proceso)
          this.alerti.error("Error al guardar el grupo vulnerable");
      });
    }
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
  //INTANCIAMOS LA VARIABLES DEL SISTEMA
  instanciaVariables() {
    this.vecEstudiante = []; this.vecConsulta = []; this.vecActividad = []; this.idConsulta = 0; this.vecGrupos = []; this.numeroHC = '';
    this.vecEstudiante.push({ estudiante: '', correo: '', nombFacultad: '', nombCarrera: '', codNivel: '', carrera: '', periodo: '', tipoEst: '', celular: '' });
    this.vecConsulta.push({ fecha: this.fechaHoy, motivo: 1, diagnostico: '', atiende: localStorage.getItem('localNombUsuario') });
    this.vecActividad.push({ fecha: this.fechaHoy, actividad: '' });
    this.vecGrupos.push({ discap: 0, porc: 0, etnia: 0, diverso: 0, grupo: 0, banDiscap: 0, banEtnia: 0, banDiverso: 0, banGrupo: 0, celular: '' });
  }
  //FUNCIÓN QUE CALCULA LA FECHA ACTUAL DEL SISTEMA
  calculoFecha() {
    var hoy = new Date();
    var diahoy = hoy.getDate() < 10 ? "0" + hoy.getDate() : hoy.getDate();
    var meshoy = (hoy.getMonth() + 1) < 10 ? "0" + (hoy.getMonth() + 1) : (hoy.getMonth() + 1);
    var annohoy = hoy.getFullYear();

    this.fechaHoy = annohoy + "-" + meshoy + "-" + diahoy;
    this.horaHoy = hoy.getHours() + "_" + hoy.getMinutes();
  }

}
